import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';

export const Navbar = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="fixed w-full z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-2 group">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white">
                <TrendingUp className="h-5 w-5" strokeWidth={2.5} />
              </div>
              <span className="text-xl font-bold tracking-tight text-slate-900 group-hover:text-blue-600 transition-colors">
                Saverr
              </span>
            </Link>
            <div className="hidden md:flex ml-12 space-x-8">
              <button
                onClick={() => scrollToSection('features')}
                className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection('rates')}
                className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
              >
                Rates
              </button>
              <button
                onClick={() => scrollToSection('security')}
                className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
              >
                Security
              </button>
              <button
                onClick={() => scrollToSection('waitlist')}
                className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
              >
                Company
              </button>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="hidden md:block text-sm font-medium text-slate-600 hover:text-slate-900">
              Log in
            </a>
            <button
              onClick={() => scrollToSection('waitlist')}
              className="px-5 py-2.5 rounded-full bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition-all shadow-lg shadow-blue-200"
            >
              Join Waitlist
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};
